// Filename - components/Sidebar.js

import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import * as FaIcons from "react-icons/fa";

import { SidebarData } from "./SidebarData";
import SubMenu from "./SubMenu";
import { IconContext } from "react-icons/lib";

const Nav = styled.div`
    background: white;
    height: 70px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,.12)
`;

const NavIcon = styled(Link)`
    margin-left: 2rem;
    font-size: 2rem;
    height: 80px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
`;

const SidebarNav = styled.nav`
    background: #687C95;
    width: 290px;
    height: 100vh;
    display: flex;
    justify-content: center;
    position: fixed;
    top: 10;
    left: ${({ sidebar }) => (sidebar ? "0" : "-100%")};
    transition: 350ms;
    z-index: 10;
`;

const SidebarWrap = styled.div`
    width: 100%;
    height:90%;
    overflow-y: scroll;
    overflow-x: hidden;
`;

const Sidebar = () => {
    const [sidebar, setSidebar] = useState(false);

    const showSidebar = () => {
        document.getElementsByName("main")[0].style.transition = "350ms";
        if (sidebar) {
            document.getElementsByName("main")[0].style.marginLeft = "0px";
        } else {
            document.getElementsByName("main")[0].style.marginLeft = "290px";
        }
        setSidebar(!sidebar)
    };
    const userData = JSON.parse(localStorage.getItem("USER_DETAILS"));
    console.log(userData?.pDATASET[0])
    return (
        <>
            <IconContext.Provider value={{ color: "#fff" }}>
                <Nav>
                    {/* <NavIcon to="#">
                        <FaIcons.FaBars
                            onClick={()=>{showSidebar()}}
                            style={{ color: "#404040",width:30,height:50 }}
                        />
                    </NavIcon> */}
                    <img src={require('../assets/menu.png')} style={{ paddingLeft: '20px', paddingRight: '10px', cursor: "pointer" }} onClick={() => { showSidebar() }} />
                    <img src={require('../assets/logo.png')} style={{ paddingLeft: '10px', width: 250 }} />
                    <div style={{ position: 'absolute', right: '20px', top: '10px', width: '200px', display: 'flex' }}>
                        <img src={require('../assets/avtar.png')} style={{ paddingLeft: '20px', paddingRight: '10px', }} />
                        <div style={{ marginTop: '10px', fontFamily: 'Roboto-Regular', fontSize: '16px' }}>Hi,{userData?.pDATASET[0]?.USERNAME}</div>
                    </div>
                </Nav>
                <SidebarNav sidebar={sidebar}>
                    <SidebarWrap className="menu_scroll">
                        {SidebarData.map((item, index) => {
                            return (
                                <SubMenu
                                    item={item}
                                    key={index}
                                />
                            );
                        })}
                    </SidebarWrap>
                </SidebarNav>
            </IconContext.Provider >
        </>
    );
};

export default Sidebar;
